import { API } from '../config/api'
import { takeEvery } from 'redux-saga/effects'
import * as analytics from '../services/analytics'
import { IAnalyticsAction } from '../types/analytics'

export function* analyticsSaga(action: IAnalyticsAction) {
  if (API.GATRACKINGID) {
    yield analytics.trackEvent('REDUX', action.type)

    if (action.error) {
      yield analytics.trackException(String(action.error), false)
    }
  }
}

export function* analyticsWatcher() {
  yield takeEvery('*', analyticsSaga)
}
